import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useGetMembersQuery } from '../redux/features/members/memberApi';
import { useGetProjectQuery } from '../redux/features/projects/projectApi';
import { useGetTaskQuery, usePostTaskMutation, useUpdateTaskMutation } from '../redux/features/tasks/tasksApi';

const AddTask = () => {
const {id}=useParams()
const navigate=useNavigate()
    const { data: projects } = useGetProjectQuery() || {};
    const { data: members } = useGetMembersQuery() || {};
    const [updateTashFunc,{isLoading:updateLoading,isSuccess:updateSuccess}]=useUpdateTaskMutation();

    const [postTaskApi,{isLoading,isError,status,isSuccess}]=usePostTaskMutation();
    const {isLoading:taskEditLoading,isError:taskEditError,data}=useGetTaskQuery(id,{skip:!id});
    const initialtask = {
        taskName: "",
        teamMember: {},
        project: {},
        deadline: "",
    }

    const [taskInfo, setTaskInfo] = useState(initialtask)



    const postTask = async(e) => {
        e.preventDefault();
        if(id){
            await updateTashFunc({id,data:{...taskInfo}});
        

        }else{

            await postTaskApi(taskInfo);
        }
        
    }
    
    useEffect(()=>{
        if(isSuccess||updateSuccess){

            setTaskInfo(initialtask);
            navigate('/');
        }
    },[isSuccess,updateSuccess]);
    useEffect(()=>{
        if(id){

            setTaskInfo({...initialtask,...data})
        }
    },[data,id]);

    

    const handleChange = (event) => {
        const { name, value } = event.target;
        setTaskInfo({ ...taskInfo, [name]:  name=='project' ? projects?.find(p=>p.id==value) :    name=="teamMember" ? members?.find(m=>m.id==value) :    value })
    }




    return (
        <>

            <div className="container relative">
                <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
                    <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
                        Create Task for Your Team
                    </h1>
                    <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
                        <form className="space-y-6" onSubmit={postTask}>
                            <div className="fieldContainer">
                                <label htmlFor="lws-taskName">Task Name</label>
                                <input value={taskInfo.taskName} onChange={handleChange} type="text" name="taskName" id="lws-taskName" required placeholder="Implement RTK Query" />
                            </div>
                            <div className="fieldContainer">
                                <label>Assign To</label>
                                <select value={taskInfo.teamMember?.id} onChange={handleChange} name="teamMember" id="lws-teamMember" required>
                                    <option value hidden selected>Select Job</option>
                                    {members?.map(member => (<option key={member.id} value={member.id} >{member.name}</option>))}


                                </select>
                            </div>
                            <div className="fieldContainer">
                                <label htmlFor="lws-projectName">Project Name</label>
                                <select value={taskInfo.project?.id} onChange={handleChange} id="lws-projectName" name="project" required>
                                    <option value hidden selected>Select Project</option>
                                    {projects?.map(project => (<option key={project.id} value={project.id} >{project.projectName}</option>))}
                                </select>
                            </div>
                            <div className="fieldContainer">
                                <label htmlFor="lws-deadline">Deadline</label>
                                <input value={taskInfo.deadline} onChange={handleChange} type="date" name="deadline" id="lws-deadline" required />
                            </div>
                            <div className="text-right">
                                <button type="submit" className="lws-submit" disabled={isLoading ||updateLoading}>Save</button>
                            </div>
                        </form>
                    </div>
                </main>

            </div>
        </>
    )
}

export default AddTask